import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAgentNetwork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAgentNetwork"><Circle cx="18.5" cy="7.5" r="2.75" stroke="currentColor"/><Circle cx="5.5" cy="16.5" r="2.75" stroke="currentColor"/><Circle cx="8.5" cy="6.5" r="3.75" stroke="currentColor"/><Circle cx="15.5" cy="17.5" r="3.75" stroke="currentColor"/><Path d="M12.3643 6.78564L15.5903 7.10081M17.9026 10.2759L16.826 13.7821M13.4093 14.1646L10.4993 9.6972M7.17742 10.2023L6.07812 13.7821M8.20985 16.8798L11.6071 17.2117" stroke="currentColor"/></CentralIconBase>;
});

export default IconAgentNetwork;
